import React from "react";
import { CTAButton, Reveal } from "../primitives";
import { Section } from "../shared";

export default function ClosingSection() {
  return (
    <Section testId="closing-section" className="grain bg-espresso py-28 text-gold md:py-44">
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <h2 className="mb-12 font-heading text-3xl font-700 uppercase leading-[1.1] tracking-tight text-gold md:text-5xl" style={{ fontWeight: 700 }}>
            Es ist kein Erfolg, wenn Du dafür andere Bereiche Deines Lebens opfern musst.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mb-4 font-heading text-4xl font-700 uppercase leading-none tracking-tight text-cognac-light md:text-7xl" style={{ fontWeight: 700 }}>
            Unverschämt Erfolgreich.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mb-12 font-heading text-2xl font-600 uppercase tracking-[0.1em] text-gold md:text-4xl" style={{ fontWeight: 600 }}>
            Ohne Abstriche.
          </p>
        </Reveal>
        <Reveal delay={0.28}>
          <CTAButton variant="gold" testId="closing-cta-button">Let's Play</CTAButton>
        </Reveal>
      </div>
    </Section>
  );
}
